<template>
  <div>
    <ExchangeBookings v-if="isAdmin"></ExchangeBookings>
  </div>
</template> 

<script>
import ExchangeBookings from "@/components/bookings/admin/ExchangeBookings";
export default {
  name: 'AdminExchanges',
  components: { ExchangeBookings },
  data() {
    return {}
  },
  computed: {
    isAdmin() {
      return this.$store.getters['auth/isAdmin'];
    }
  }
}
</script>

<style lang="scss" scoped>

</style>